@if ((!hideDataProtectionOnHomePage && !eventId) || (!hideDataProtectionOnEventPage && eventId)) {
  <div
    class="border-color-default bg-white flex flex-column justify-content-between align-items-center border-top-1 p-8 lg:flex-row"
  >
    <div class="cookie-content-container overflow-y-auto m-b-8 md:m-b-0">
      <div
        class="text-justify md:m-r-8"
        data-translation="cookies.popup.text"
        role="button"
        tabindex="0"
        [attr.aria-label]="'a11y.cookie-popup.text.url' | translate"
        [innerHTML]="textWithLink"
        (click)="onClickText($event)"
        (keydown.enter)="onClickText($event)"
        (keydown.space)="onClickText($event)"
      ></div>
    </div>

    <ls-button
      data-nested-translation="cookies.popup.agree"
      data-testid="cookies-popup-agree-button"
      [styleClass]="'button-primary'"
      [color]="'primary'"
      [size]="'md'"
      [label]="'cookies.popup.agree' | translate | hideTranslation"
      (onClick)="onClose($event)"
    />
  </div>
}
